// * Manage Mail 공통 그리드 컬럼 정의
export const manageMailRecipientsGridColumns = [
  { title: 'Name', key: 'name', width: 120 },
  { title: 'Email', key: 'email', width: 180  },
  { title: 'Type', key: 'mailType', width: 100 },
  { title: 'Category', key: 'mailCategory', width: 120 },
  { title: 'Registered Date', key: 'createdDate', width: 120 },
  { title: 'Mail Send', key: 'mailSend', width: 100 }
]
